export const commonConstant = {
  maxFormFieldLength: 40,
} as const;

export const inputTypes = {
  input: 'input',
  date: 'date',
  switch: 'switch',
  select: 'select',
  number: 'number',
} as const;

export const defaultPageSize = 50;

/** Client-side tables/graphs paginate only when row count exceeds this threshold. */
export const clientPaginationThreshold = 10;

export const PipeDatapageSizeOptions = ['50', '100'];

export const commonConstants = {
  maxFormFieldLength: 40,
  defaultPageSize: 50,
  clientPaginationThreshold: 10,
  PipeDatapageSizeOptions: ['50', '100'],
  inputTypes: {
    input: 'input',
    date: 'date',
    switch: 'switch',
    select: 'select',
    number: 'number',
  },
  commonConstant: {
    maxFormFieldLength: 40,
  },
  reportTabKeys: {
    projectStatus: 'projectStatus',
    pipeData: 'pipeData',
    projectSummary: 'projectSummary',
  },
  showEmailModalFor: {
    sequence: 'sequence',
    pipeData: 'pipeData',
    projectSummary: 'projectSummary',
  },
};
